import React from 'react'
import userService from '../helpers/user.service'

export default function Header ({ loggedIn }) {
  const logout = () => {
    userService.logout()
  }
  return (
    <header className="header fixed-header">
        <div className="wrapper">
            <div className="top">
                <h1 id="logo" className="align">
                    <a href="/espanol/" tabIndex="-1" className="logo anchor" style={{ backgroundImage: `url(${process.env.REACT_APP_LOGO})` }}><span className="notVisible"></span></a>
                </h1>
                {loggedIn ? <a id="login-btn" onClick={logout} className='btn hidden-md hidden-lg' title="Login btn"></a> : '' }
            </div>
            <nav className="nav align-m"><h2 className="notVisible">Navegación</h2><div className="menu-viewport align scrollable">
                <div className="wrapper">
                    <ul id="menu">
                        <li className="">
                            {loggedIn ? <button onClick={logout} title="Contáctenos">Cerrar sesión</button> : ''}
                        </li>
                    </ul>
                </div>
        </div>
        <div className="overlay hidden-md hidden-lg"></div>
        </nav></div>
    </header>
  )
}
